<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="feedback.publicId === '0'"/>
    <div v-else>
      <div class="card">
        <div class="card-body">
          <div class="p-4">
            <div class="mt-3">
              <h1 class="mt-1 mb-3 text-primary" v-if="feedback.recordName">{{feedback.recordName}}</h1>
            </div>
            <div class="row" v-if="feedback.currentStatus">
              <div class="col-md-4">
                <b-card class="text-white-50" :style="feedback.currentStatus.status.color">
                  <h5 class="mt-0 mb-4 text-white">
                    <i class="mdi mdi-bullseye-arrow me-3"></i> {{ feedback.currentStatus.status.name }}
                  </h5>
                  <p class="card-text text-white">2020-03-09</p>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="row mt-5 h5">
                  <div class="col-5 mb-4"><b>Customer Name:</b></div>
                  <div class="col-6 mb-4"><span v-if="feedback.customer !== null">{{feedback.customer.name}}</span></div>
                  <div class="col-5 mb-4"><b>Restaurant Capacity:</b></div>
                  <div class="col-6 mb-4">{{ feedback.capacity }}</div>
                  <div class="col-5 mb-4"><b>Monthly consumption (Soy Sauce):</b></div>
                  <div class="col-6 mb-4">{{ feedback.monthlyConsumption }}</div>
                  <div class="col-5 mb-4"><b>Area Zone:</b></div>
                  <div class="col-6 mb-4"><span v-if="feedback.zone">{{feedback.zone.name}}</span></div>
                  <span v-if="feedback.brands">
                    <div class="col-5 mb-4"><b>Brands:</b></div>
                    <div class="col-6 mb-4" v-for="brand in feedback.brands" :key="brand.publicId">
                      <span class="badge rounded-pill font-size-11 badge-soft-success mx-2">{{ brand.name }}</span>
                    </div>
                  </span>
                  <span v-if="feedback.suppliers">
                    <div class="col-5 mb-4"><b>Suppliers:</b></div>
                    <div class="col-6 mb-4" v-for="supplier in feedback.suppliers" :key="supplier.publicId">
                      <span class="badge rounded-pill font-size-11 badge-soft-info mx-2">{{supplier.name}}</span>
                    </div>
                  </span>
  <!--                <span v-if="feedback.productsOfInterest">-->
  <!--                  <div class="col-5 mb-4"><b>Products of Interest:</b></div>-->
  <!--                  <div class="col-6 mb-4" v-for="product in feedback.productsOfInterest" :key="product.publicId">-->
  <!--                    <span class="badge rounded-pill font-size-11 badge-soft-danger mx-2">{{product.productCode.productName}}</span>-->
  <!--                  </div>-->
  <!--                </span>-->
                </div>
                <div class="col-12 mb-4 mt-5"><b>Contact Persons:</b></div>
                <div class="col-12" v-for="contact in feedback.personsInCharge" :key="contact.publicId">
                  <div class="d-flex">
                    <div class="avatar-md me-4">
                          <span
                              class="avatar-title rounded-circle bg-light text-danger font-size-16"
                          >
                            <img src="@/assets/images/companies/img-1.png" alt height="30" />
                          </span>
                    </div>

                    <div class="flex-grow-1 overflow-hidden">
                      <h5 class="text-truncate font-size-15">
                        <a href="javascript: void(0);" class="text-dark">{{ contact.name }}</a>
                      </h5>
                      <h6>{{contact.title}}</h6>
                      <p class="text-muted mb-2">{{contact.email}}</p>
                      <p>{{contact.tel}}</p>
                    </div>
                  </div>
                  <hr class="my-4" />
                </div>
              </div>
              <div class="col-xl-6">
                <div class="row mt-5 h5">
                  <div class="col-12 mb-4"><b>Additional Information:</b></div>
                  <div class="col-12 mb-4">
                    <span v-html="feedback.feedback"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-3">Orders</h4>
          <form class="mb-5">
  <!--          <div class="row">-->
  <!--            <div class="col-xl col-sm-6">-->
  <!--              <div class="form-group mt-3 mb-0">-->
  <!--                <label>Start Date :</label>-->
  <!--                <date-picker v-model="filter.start_date" :first-day-of-week="1" lang="en"></date-picker>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--            <div class="col-xl col-sm-6">-->
  <!--              <div class="form-group mt-3 mb-0">-->
  <!--                <label>End Date :</label>-->
  <!--                <date-picker v-model="filter.start_date" :first-day-of-week="1" lang="en"></date-picker>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--            <div class="col-xl col-sm-6">-->
  <!--              <div class="form-group mt-3 mb-0">-->
  <!--                <label>Staff Member :</label>-->
  <!--                <multiselect v-model="filter.start_date" :options="category_options" placeholder="Select one" label="label" track-by="value"></multiselect>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--            <div class="col-xl col-sm-6 align-self-end">-->
  <!--              <div class="mt-3 button-items">-->
  <!--                <button type="button" class="btn btn-secondary w-md">-->
  <!--                  Filter-->
  <!--                </button>-->
  <!--                <button type="button" class="btn btn-danger w-md">-->
  <!--                  Reset-->
  <!--                </button>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--          </div>-->
          </form>
          <div class="row mb-5">
            <div class="col-lg-2">
              <div class="card border border-primary">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Comments</p>
                      <h5 class="mb-0">{{ feedback.comments.length }}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-book-bookmark"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="card border border-primary">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Visits</p>
                      <h5 class="mb-0">{{getCount(feedback.visits, "Visit")}}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-note"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="card border border-primary">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Calls</p>
                      <h5 class="mb-0">{{getCount(feedback.visits, "Call")}}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-message-square-dots"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="card border border-primary">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Emails</p>
                      <h5 class="mb-0">{{getCount(feedback.visits, "Email")}}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-book-bookmark"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="card border border-primary">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">SMS</p>
                      <h5 class="mb-0">{{getCount(feedback.visits, "SMS")}}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-note"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="card border border-primary">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Demo</p>
                      <h5 class="mb-0">{{getCount(feedback.visits, "Demo")}}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-message-square-dots"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-tabs pills justified content-class="p-3 text-muted mx-4">
            <b-tab active class="border-0">
              <template v-slot:title>
                <span class="d-none d-sm-inline-block my-2">Comments</span>
              </template>
              <comments :comments="feedback.comments" @updateProfile="updateSaleProfileData"/>
            </b-tab>
  <!--          <b-tab>-->
  <!--            <template v-slot:title>-->
  <!--              <span class="d-none d-sm-inline-block my-2">Images</span>-->
  <!--            </template>-->
  <!--            <images/>-->
  <!--          </b-tab>-->
            <b-tab active class="border-0">
              <template v-slot:title>
                <span class="d-none d-sm-inline-block my-2">Vists</span>
              </template>
              <visits :visits="feedback.visits" @updateProfile="updateSaleProfileData"/>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-none d-sm-inline-block my-2">Turnover</span>
              </template>
              <turn-over :turnover="feedback.turnoverPaginated" @updateProfile="updateSaleProfileData" @changeTurnoverPage="changeTurnoverPage"/>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-none d-sm-inline-block my-2">Ownership</span>
              </template>
              <ownership :ownership="feedback.ownership" @updateProfile="updateSaleProfileData"/>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import Comments from "@/components/customers/sales-profile/comments";
import Visits from "@/components/customers/sales-profile/visits";
import TurnOver from "@/components/customers/sales-profile/turn-over";
import Ownership from "@/components/customers/sales-profile/ownership";
import {SINGLE_SALES_PROFILE} from "@/gql/customers";
import TableLoading from "@/components/TableLoading";

export default {
  page: {
    title: "Single Sales Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, Ownership, TurnOver, Visits, Comments, PageHeader, Layout},
name: "single-sales-profile",
  data() {
    return {
      title: "Single Sales Profile",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Single Sales Profile",
          active: true
        }
      ],
      turnoverCurrentPage: 1,
      turnoverSearchKeyword: "",
      filter:{
        start_date:"",
        end_date: "",
        staff: ""
      },
      category_options: [
        { value: '1', label: 'Category 1' },
        { value: '2', label: 'Category 2' }
      ],
      feedback: {
        publicId: '0',
        recordName: "",
        customer: {
          name: ""
        },
        name: "",
        zone: {
          name: ""
        },
        feedback: "",
        capacity: "",
        monthlyConsumption: "",
        currentStatus: {
          status: {
            name: "",
            color: ""
          }
        },
        brands: [{
          publicId: "",
          name: ""
        }],
        suppliers: [{
          publicId: "",
          name: ""
        }],
        productsOfInterest: [{
          publicId: "",
          productCode: {
            publicId: "",
            productName: ""
          }
        }],
        personsInCharge:[ {
          publicId: "",
          title: "",
          name: "",
          tel: "",
          email: ""
        }],
        ownership: [],
        comments: [],
        visits: [],
        turnoverPaginated: {}
      }
    }
  },
  apollo: {
    feedback: {
      query: SINGLE_SALES_PROFILE,
      variables(){
        return {
          id: this.$route.params.id,
          turnoverCurrentPage: this.turnoverCurrentPage,
          turnoverSearchKeyword: this.turnoverSearchKeyword
        }
      }
    }
  },

  methods: {
    getCount(data, name){
      var countfiltered = data.filter(element => {
        return element.salesType.name === name
      })
      return countfiltered.length
    },
    updateSaleProfileData(){
      this.$apollo.queries.feedback.refetch()
    },
    changeTurnoverPage(page, searchWord){
      this.turnoverCurrentPage = page
      this.turnoverSearchKeyword = searchWord
    }
  }
}
</script>

<style scoped>

</style>
